import { z } from 'zod';

import {
    schemaEuropaceAntragsteller,
    schemaEuropaceBeschaeftigung,
    schemaEuropaceHerkunft,
    schemaEuropacePersonendaten,
    schemaEuropaceWohnsituation,
} from '../Antragsteller';
import {
    schemaEuropaceFahrzeugkauf,
    schemaEuropaceFinanzbedarfRatenschutz,
    schemaEuropaceFinanzierungswunsch,
    schemaEuropaceFinanzierungszweck,
} from '../Finanzbedarf';
import {
    schemaEuropaceUpdateBausparvertrag,
    schemaEuropaceUpdateDispositionskredit,
    schemaEuropaceUpdateEhegattenunterhalt,
    schemaEuropaceUpdateEinkunftAusNebentaetigkeit,
    schemaEuropaceUpdateImmobilie,
    schemaEuropaceUpdateKind,
    schemaEuropaceUpdateKontoverbindung,
    schemaEuropaceUpdateKreditkarte,
    schemaEuropaceUpdateLeasing,
    schemaEuropaceUpdateLebensversicherung,
    schemaEuropaceUpdateMietausgabe,
    schemaEuropaceUpdatePrivateKrankenversicherung,
    schemaEuropaceUpdateRatenkredit,
    schemaEuropaceUpdateSonstigeAusgabe,
    schemaEuropaceUpdateSonstigeEinnahme,
    schemaEuropaceUpdateSonstigeVerbindlichkeit,
    schemaEuropaceUpdateUnbefristeteZusatzrente,
    schemaEuropaceUpdateUnterhaltsverpflichtung,
} from '../Update';

export const schemaGraphQLMutationFields = z.discriminatedUnion('type', [
    z.object({
        antragsteller: schemaEuropaceAntragsteller,
        type: z.literal('addAntragsteller'),
    }),
    z.object({ id: z.string(), type: z.literal('deleteAntragsteller') }),
    z.object({
        antragstellerId: z.string(),
        personendaten: schemaEuropacePersonendaten,
        type: z.literal('updatePersonendaten'),
    }),
    z.object({
        antragstellerId: z.string(),
        type: z.literal('updateWohnsituation'),
        wohnsituation: schemaEuropaceWohnsituation,
    }),
    z.object({ antragstellerId: z.string(), herkunft: schemaEuropaceHerkunft, type: z.literal('updateHerkunft') }),
    z.object({
        antragstellerId: z.string(),
        beschaeftigung: schemaEuropaceBeschaeftigung,
        type: z.literal('updateBeschaeftigung'),
    }),
    z.object({
        bausparvertrag: schemaEuropaceUpdateBausparvertrag,
        index: z.number(),
        type: z.literal('addBausparvertrag'),
    }),
    z.object({
        bausparvertrag: schemaEuropaceUpdateBausparvertrag,
        id: z.string(),
        type: z.literal('updateBausparvertrag'),
    }),
    z.object({ id: z.string(), type: z.literal('deleteBausparvertrag') }),
    z.object({
        dispositionskredit: schemaEuropaceUpdateDispositionskredit,
        index: z.number(),
        type: z.literal('addDispositionskredit'),
    }),
    z.object({
        dispositionskredit: schemaEuropaceUpdateDispositionskredit,
        id: z.string(),
        type: z.literal('updateDispositionskredit'),
    }),
    z.object({ id: z.string(), type: z.literal('deleteDispositionskredit') }),
    z.object({
        ehegattenunterhalt: schemaEuropaceUpdateEhegattenunterhalt,
        index: z.number(),
        type: z.literal('addEhegattenunterhalt'),
    }),
    z.object({
        ehegattenunterhalt: schemaEuropaceUpdateEhegattenunterhalt,
        id: z.string(),
        type: z.literal('updateEhegattenunterhalt'),
    }),
    z.object({ id: z.string(), type: z.literal('deleteEhegattenunterhalt') }),
    z.object({
        einkunftAusNebentaetigkeit: schemaEuropaceUpdateEinkunftAusNebentaetigkeit,
        index: z.number(),
        type: z.literal('addEinkunftAusNebentaetigkeit'),
    }),
    z.object({
        einkunftAusNebentaetigkeit: schemaEuropaceUpdateEinkunftAusNebentaetigkeit,
        id: z.string(),
        type: z.literal('updateEinkunftAusNebentaetigkeit'),
    }),
    z.object({ id: z.string(), type: z.literal('deleteEinkunftAusNebentaetigkeit') }),
    z.object({ immobilie: schemaEuropaceUpdateImmobilie, index: z.number(), type: z.literal('addImmobilie') }),
    z.object({ id: z.string(), immobilie: schemaEuropaceUpdateImmobilie, type: z.literal('updateImmobilie') }),
    z.object({ id: z.string(), type: z.literal('deleteImmobilie') }),
    z.object({ index: z.number(), kind: schemaEuropaceUpdateKind, type: z.literal('addKind') }),
    z.object({ id: z.string(), kind: schemaEuropaceUpdateKind, type: z.literal('updateKind') }),
    z.object({ id: z.string(), type: z.literal('deleteKind') }),
    z.object({ kontoverbindung: schemaEuropaceUpdateKontoverbindung, type: z.literal('updateKontoverbindung') }),
    z.object({ index: z.number(), kreditkarte: schemaEuropaceUpdateKreditkarte, type: z.literal('addKreditkarte') }),
    z.object({ id: z.string(), kreditkarte: schemaEuropaceUpdateKreditkarte, type: z.literal('updateKreditkarte') }),
    z.object({ id: z.string(), type: z.literal('deleteKreditkarte') }),
    z.object({ index: z.number(), leasing: schemaEuropaceUpdateLeasing, type: z.literal('addLeasing') }),
    z.object({ id: z.string(), leasing: schemaEuropaceUpdateLeasing, type: z.literal('updateLeasing') }),
    z.object({ id: z.string(), type: z.literal('deleteLeasing') }),
    z.object({
        index: z.number(),
        lebensversicherung: schemaEuropaceUpdateLebensversicherung,
        type: z.literal('Lebensversicherung'),
    }),
    z.object({
        id: z.string(),
        lebensversicherung: schemaEuropaceUpdateLebensversicherung,
        type: z.literal('updateLebensversicherung'),
    }),
    z.object({ id: z.string(), type: z.literal('deleteLebensversicherung') }),
    z.object({ index: z.number(), mietausgabe: schemaEuropaceUpdateMietausgabe, type: z.literal('addMietausgabe') }),
    z.object({ id: z.string(), mietausgabe: schemaEuropaceUpdateMietausgabe, type: z.literal('updateMietausgabe') }),
    z.object({ id: z.string(), type: z.literal('deleteMietausgabe') }),
    z.object({
        index: z.number(),
        privateKrankenversicherung: schemaEuropaceUpdatePrivateKrankenversicherung,
        type: z.literal('addPrivateKrankenversicherung'),
    }),
    z.object({
        id: z.string(),
        privateKrankenversicherung: schemaEuropaceUpdatePrivateKrankenversicherung,
        type: z.literal('updatePrivateKrankenversicherung'),
    }),
    z.object({ id: z.string(), type: z.literal('deletePrivateKrankenversicherung') }),
    z.object({ index: z.number(), ratenkredit: schemaEuropaceUpdateRatenkredit, type: z.literal('addRatenkredit') }),
    z.object({ id: z.string(), ratenkredit: schemaEuropaceUpdateRatenkredit, type: z.literal('updateRatenkredit') }),
    z.object({ id: z.string(), type: z.literal('deleteRatenkredit') }),
    z.object({
        index: z.number(),
        sonstigeAusgabe: schemaEuropaceUpdateSonstigeAusgabe,
        type: z.literal('addSonstigeAusgabe'),
    }),
    z.object({
        id: z.string(),
        sonstigeAusgabe: schemaEuropaceUpdateSonstigeAusgabe,
        type: z.literal('updateSonstigeAusgabe'),
    }),
    z.object({ id: z.string(), type: z.literal('deleteSonstigeAusgabe') }),
    z.object({
        index: z.number(),
        sonstigeEinnahme: schemaEuropaceUpdateSonstigeEinnahme,
        type: z.literal('addSonstigeEinnahme'),
    }),
    z.object({
        id: z.string(),
        sonstigeEinnahme: schemaEuropaceUpdateSonstigeEinnahme,
        type: z.literal('updateSonstigeEinnahme'),
    }),
    z.object({ id: z.string(), type: z.literal('deleteSonstigeEinnahme') }),
    z.object({
        index: z.number(),
        sonstigeVerbindlichkeit: schemaEuropaceUpdateSonstigeVerbindlichkeit,
        type: z.literal('addSonstigeVerbindlichkeit'),
    }),
    z.object({
        id: z.string(),
        sonstigeVerbindlichkeit: schemaEuropaceUpdateSonstigeVerbindlichkeit,
        type: z.literal('updateSonstigeVerbindlichkeit'),
    }),
    z.object({ id: z.string(), type: z.literal('deleteSonstigeVerbindlichkeit') }),
    z.object({
        index: z.number(),
        type: z.literal('addUnbefristeteZusatzrente'),
        unbefristeteZusatzrente: schemaEuropaceUpdateUnbefristeteZusatzrente,
    }),
    z.object({
        id: z.string(),
        type: z.literal('updateUnbefristeteZusatzrente'),
        unbefristeteZusatzrente: schemaEuropaceUpdateUnbefristeteZusatzrente,
    }),
    z.object({ id: z.string(), type: z.literal('deleteUnbefristeteZusatzrente') }),
    z.object({
        index: z.number(),
        type: z.literal('addUnterhaltsverpflichtung'),
        unterhaltsverpflichtung: schemaEuropaceUpdateUnterhaltsverpflichtung,
    }),
    z.object({
        id: z.string(),
        type: z.literal('updateUnterhaltsverpflichtung'),
        unterhaltsverpflichtung: schemaEuropaceUpdateUnterhaltsverpflichtung,
    }),
    z.object({ id: z.string(), type: z.literal('deleteUnterhaltsverpflichtung') }),
    z.object({ fahrzeugkauf: schemaEuropaceFahrzeugkauf, type: z.literal('updateFahrzeugkauf') }),
    z.object({
        finanzierungswunsch: schemaEuropaceFinanzierungswunsch,
        type: z.literal('updateFinanzierungswunsch'),
    }),
    z.object({
        finanzierungszweck: schemaEuropaceFinanzierungszweck,
        type: z.literal('updateFinanzierungszweck'),
    }),
    z.object({
        antragstellerId: z.string(),
        ratenschutz: schemaEuropaceFinanzbedarfRatenschutz,
        type: z.literal('updateRatenschutz'),
    }),
    z.object({ kommentare: z.array(z.string()), type: z.literal('addKommentare') }),
    z.object({ partnerId: z.string(), type: z.literal('updateBearbeiter') }),
    z.object({ partnerId: z.string(), type: z.literal('updateKundenbetreuer') }),
]);

export type SchemaGraphQLMutationFields = z.infer<typeof schemaGraphQLMutationFields>;
